var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3244 7.68788V6.26288C17.3244 3.41286 15.1869 1.01286 12.4869 0.750361C10.9494 0.600361 9.5244 1.12536 8.3994 2.13786C7.3119 3.11286 6.7119 4.53788 6.7119 6.00038V7.68788C4.4994 7.91288 2.77441 9.78788 2.77441 12.0379V19.1254C2.77441 21.4129 4.6494 23.2504 6.8994 23.2504H17.1369C19.4244 23.2504 21.2994 21.3754 21.2994 19.0879V12.0004C21.2619 9.78788 19.5369 7.95038 17.3244 7.68788ZM8.8869 2.70036C9.8619 1.83786 11.0994 1.38786 12.4119 1.50036C14.7369 1.68786 16.5744 3.78788 16.5744 6.26288V7.65038H7.4244V6.00038C7.4244 4.76288 7.9494 3.56286 8.8869 2.70036ZM20.5494 19.0879C20.5494 20.9629 19.0119 22.5004 17.1369 22.5004H6.8619C4.9869 22.5004 3.48691 20.9629 3.48691 19.1254V12.0754C3.48691 10.0504 5.1369 8.43788 7.1244 8.43788H16.8369C18.8619 8.43788 20.5494 10.0504 20.5494 12.0004V19.0879Z",
    fill: "#969696"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.6128C11.775 13.6128 11.625 13.7628 11.625 13.9878V14.9628V15.9378V17.9253C11.625 18.1503 11.775 18.3003 12 18.3003C12.225 18.3003 12.375 18.1503 12.375 17.9253V15.9378V14.9628V13.9878C12.375 13.7628 12.225 13.6128 12 13.6128Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockAlt);
export default __webpack_public_path__ + "static/media/lock-alt.fd7f1619fd7cdc667313becd8d2a9fbe.svg";
export { ForwardRef as ReactComponent };